import { render, staticRenderFns } from "./ArrayField.vue?vue&type=template&id=a5a2b7f0&scoped=true&"
import script from "./ArrayField.vue?vue&type=script&lang=js&"
export * from "./ArrayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a2b7f0",
  null
  
)

export default component.exports